/**
 * Logging utilities for milla-ads SDK
 * @module lib/logger
 */

function logInfo(...args) {
  if (typeof window !== 'undefined' && window.console && window.console.info) {
    window.console.info('[milla-ads]', ...args);
  }
}

function logDebug(...args) {
  if (typeof window !== 'undefined' && window._millaDebugAds === true) {
    logInfo(...args);
  }
}

function logWarn(...args) {
  if (typeof window !== 'undefined' && window.console && window.console.warn) {
    window.console.warn('[milla-ads]', ...args);
  }
}

function logError(...args) {
  if (typeof window !== 'undefined' && window.console && window.console.error) {
    window.console.error('[milla-ads]', ...args);
  }
}

module.exports = {
  logInfo,
  logDebug,
  logWarn,
  logError
};
